module.exports = __webpack_public_path__ + "static/media/slider1.835fe0a6.png";